module.exports = __webpack_public_path__ + "static/img/Ricky-Stuart.96eda98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ricky-Stuart.jpg
// module id = 0l3x
// module chunks = 0